export default __webpack_public_path__ + "static/media/a011-fsi-07.cc89afc4.svg";